import React, { useState } from 'react'
import '../../../../styles/SwipeableComponent.css'

const SwipeableComponent = ({ children, rightButton }) => {
  const [startX, setStartX] = useState(null)
  const [isSwiped, setIsSwiped] = useState(false)

  const handleSwipeStart = event => {
    setStartX(getClientX(event))
  }

  const handleSwipeMove = event => {
    if (!startX) return

    const currentX = getClientX(event)
    const distance = startX - currentX

    if (distance > 50) {
      setIsSwiped(true)
    } else {
      setIsSwiped(false)
    }
  }

  const handleSwipeEnd = () => {
    setStartX(null)
  }

  const getClientX = event => {
    return event.touches ? event.touches[0].clientX : event.clientX
  }

  return (
    <div
      className={`swipeable-container ${isSwiped ? 'swiped' : ''}`}
      onTouchStart={handleSwipeStart}
      onTouchMove={handleSwipeMove}
      onTouchEnd={handleSwipeEnd}
      onMouseDown={handleSwipeStart}
      onMouseMove={handleSwipeMove}
      onMouseUp={handleSwipeEnd}
    >
      <div className="swipeable-content">{children}</div>
      {isSwiped && (
        <div className="button-container">
          {rightButton && rightButton}
        </div>
      )}
    </div>
  )
}

export default SwipeableComponent
